const moduleMap = {
	"./tableUserGroups": () => {
		return __webpack_require__.e(690).then(() => (() => ((__webpack_require__(3690)))));
	},
	"./newUser": () => {
		return __webpack_require__.e(692).then(() => (() => ((__webpack_require__(3692)))));
	},
	"./detailUser": () => {
		return __webpack_require__.e(167).then(() => (() => ((__webpack_require__(1167)))));
	},
	"./newTeam": () => {
		return __webpack_require__.e(441).then(() => (() => ((__webpack_require__(2441)))));
	},
	"./detailGroup": () => {
		return __webpack_require__.e(795).then(() => (() => ((__webpack_require__(7795)))));
	},
	"./permissionsBrands": () => {
		return __webpack_require__.e(887).then(() => (() => ((__webpack_require__(3887)))));
	},
	"./permissionsProjects": () => {
		return __webpack_require__.e(578).then(() => (() => ((__webpack_require__(6578)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});